import type { PersonId } from '@fs/zion-tree-types'
import type { SwrResponse } from './useSwrRequest'
import { useSwrRequest } from './useSwrRequest'

export type DeleteConstraint = {
  personDeleteConstraint:
    | 'CAN_DELETE_PERSON'
    | 'CANNOT_DELETE_TOMBSTONED_PERSON'
    | 'CANNOT_DELETE_PERSON_NOT_FOUND'
    | 'CANNOT_DELETE_LOCKED_PERSON'
    | 'CANNOT_DELETE_PERSON_IN_LOCKED_RELATIONSHIP'
    | 'CANNOT_DELETE_NO_DELETE_ACCESS'
    | 'CANNOT_DELETE_HOME_PERSON'
    | 'CANNOT_DELETE_WITH_MULTIPLE_CONTRIBUTORS'
}

export default function useDeleteConstraint(
  personId: PersonId
): SwrResponse<DeleteConstraint> & { deleteConstraint: DeleteConstraint | undefined } {
  const response = useSwrRequest<DeleteConstraint>(
    `/service/tree/tree-data/v8/person/${personId}/delete-constraint`,
    undefined,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )
  return { ...response, deleteConstraint: response.data }
}
